import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const ClearCart = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isClearAll, setIsClear] = useState(actionStep?.action?.data.isClearAll ?? true);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = {
            type: isClearAll ? ActionType.CLEAR_CART : ActionType.CLEAR_ACTIVE_PRODUCT,
            data: { isClearAll }
        };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem }));
        }
    }, [actionStep, dispatch, id, isClearAll]);

    return (
        <div className="function-add-cart-note-wrapper">
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setIsClear(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Clear cart" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText
                            text="This will clear all items currently in the cart"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isClearAll} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setIsClear(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText
                            text="Clear active product"
                            size="xs"
                            weight="medium-heavy"
                            translatePrefix="popup.actionBuilder."
                        />
                        <OliverText
                            text="This will clear the active product in cart"
                            size="xs"
                            weight="light"
                            translatePrefix="popup.actionBuilder."
                        />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isClearAll} label="" value="" custom={false} />
                </div>
            </div>
        </div>
    );
};

export default ClearCart;
